import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import React, {useCallback, useMemo, useState} from "react";
import {Card, Col, Row, Spin, Table, Tooltip} from "antd";

import {MyBreadcrumb, MyButton, MyText} from "../../components";
import {selectStore} from "../../store/selector";
import {RootState} from "../../store";
import {fetchScheduleAction} from "../../store/pages/schedule/actions";


export const Schedule = () => {
  const {t} = useTranslation("common")
  const dispatch = useDispatch();

  const tableInitialState = {
    columns: [] as any,
    data: [] as any
  }

  const {schedule: {schedule: scheduleState}}: RootState = useSelector(selectStore)

  const [tableData, setTableData] = useState(tableInitialState)


  const handlePeriodClick = useCallback((ts: any) => {
    dispatch(fetchScheduleAction({ts: ts}))
  }, [])

  const headerContent = useMemo(() => {
    const headerItem = scheduleState.data?.header
    return (
      <Row justify='space-between' align='middle'>
        <Col>
          <MyButton ghost type='primary' title={headerItem?.previous?.dates}
                    onClick={() => handlePeriodClick(headerItem?.previous?.ts)}/>
        </Col>

        <Col>
          <MyText weight={500} size={18}>
            {headerItem?.current?.dates}
          </MyText>
        </Col>

        <Col>
          <MyButton ghost type='primary' title={headerItem?.next?.dates}
                    onClick={() => handlePeriodClick(headerItem?.next?.ts)}/>
        </Col>
      </Row>
    )
  }, [scheduleState.data])

  useMemo(() => {
    const columns = scheduleState.data?.columns?.map((column: any, columnIdx: any) => {
      return {
        id: `${columnIdx}-${column.title}-${column.dataIndex}`,
        key: `${columnIdx}-${column.title}-${column.dataIndex}`,
        title: column.title,
        dataIndex: column.dataIndex,
        width: 160,
        render: (text: any, record: any, index: any) => {
          return (
            <Row justify="center" align="middle" key={`col-${index}-${columnIdx}-${column.dataIndex}`}>
              <Col>
                <div dangerouslySetInnerHTML={{__html: text}}/>
              </Col>
            </Row>
          )
        }
      }
    })

    setTableData({
      columns: columns,
      data: scheduleState.data?.data?.map((item: any, index: any) => ({...item, id: index}))
    })
  }, [scheduleState.data])

  const mainContent = useMemo(() => {
    return (
      <Table columns={tableData.columns} dataSource={tableData.data} bordered pagination={false}
             rowKey={(record) => record.id}/>
    )
  }, [tableData.data])

  return (
    <>
      <MyBreadcrumb title="Расписание"/>

      <Row justify='center'>
        <Col span={20}>
          <Card>
            <Spin spinning={scheduleState.loading}>
              <Row gutter={[16, 32]}>
                <Col span={24}>
                  {headerContent}
                </Col>

                <Col span={24}>
                  {mainContent}
                </Col>
              </Row>
            </Spin>
          </Card>
        </Col>
      </Row>

    </>
  );
}